import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AssistantPage } from '@/modules/assistant/public';

export const Route = createFileRoute('/_app/assistente')({
  validateSearch: z.object({
    /** Conversa aberta — recarregar a página ou abrir pela gaveta da aula cai nela. */
    conversa: z.string().optional().catch(undefined),
  }),
  component: function AssistantRoute() {
    const { conversa } = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <AssistantPage
        conversationId={conversa}
        onNavigate={(id, options) => void navigate({ search: { conversa: id }, replace: options?.replace })}
      />
    );
  },
});
